/* src/app/account/manage-users/manage-users.component.scss */
.add-user {
  margin-top: 15px;
}
.modal-body {
  color: #242424;
}
/*# sourceMappingURL=manage-users.component.css.map */
